import fetchRetry from "../utils/fetchRetry";
import { NOT_AUTHORIZED, NOT_AUTHORIZED_STATUS } from "../utils/constants";
import { getPuCardDeckPlayerUrl, getPuPlayerProgressUrl } from "../utils/urlUtils";

const getPlayerProgressMetadataUrl = () => {
    const ppUrl = getPuPlayerProgressUrl();
    return ppUrl + "/playerprogress/metadata"
}

const getCardDeckPlayerMetadataUrl = () => {
    const ppUrl = getPuCardDeckPlayerUrl();
    return ppUrl + "/metadata"
}

const getPlayerProgressMigrationUrl = () => {
    const ppUrl = getPuPlayerProgressUrl();
    return ppUrl + "/playerprogress/migration"
}

export const getPrincipalId = (authToken: string) => {
    return new Promise((resolve, reject) => {
        var metadataUrl = null;
        if (getPuPlayerProgressUrl() != null) {
            metadataUrl = getPlayerProgressMetadataUrl();
        } else if (getPuCardDeckPlayerUrl() != null) {
            metadataUrl = getCardDeckPlayerMetadataUrl();
        } else {
            resolve("")
            return;
        }

        const headers = new Headers();
        if (authToken != "invalid_token") {
            headers.append("Authorization", authToken);
        }
        var myInit = {
            method: "GET",
            headers: headers
        };
        fetchRetry(metadataUrl, myInit).then(resp => {
            if (NOT_AUTHORIZED_STATUS.includes(resp.status)) {
                reject(NOT_AUTHORIZED);
            } else if (resp.status >= 300) {
                reject();
            } else {
                resp.json().then(function (data) {
                    resolve(data.metadata.principal_id);
                });
            }
        }).catch(err => {
            reject(err);
        });
    });
}

export const checkMigrationStatus = (authToken: string) => {
    return new Promise((resolve, reject) => {
        var metadataUrl = null;
        if (getPuPlayerProgressUrl() != null) {
            metadataUrl = getPlayerProgressMigrationUrl();
        } else {
            resolve("")
            return;
        }

        const headers = new Headers();
        if (authToken != "invalid_token") {
            headers.append("Authorization", authToken);
        }
        var myInit = {
            method: "POST",
            headers: headers
        };
        fetchRetry(metadataUrl, myInit).then(() => {
            resolve(undefined)
        }).catch(err => {
            reject(err);
        });
    });
}